<template>
  <div class="sa-list">
    <v-banner color="error" dark v-if="fetchAllError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchAllError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all service accounts. You can add, edit or delete service accounts. Each service account has several settings:</span>
        <ul>
          <li><strong>Client ID</strong>: must begin with 'sa-' prefix. This is the string that will be used in your service account to generate tokens.</li>
          <li><strong>Client Secret</strong>: will be automatically generated when creating a new service account. You need this credential to generate tokens.</li>
          <li><strong>Name</strong>: human readable name of service account for documentation purposes.</li>
          <li><strong>Description</strong>: quick overview of service account functionalities.</li>
        </ul>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <ServiceAccountsTable
        v-on:refresh="refresh"
        v-on:createNew="openServiceAccountCreationDialog"
        v-on:editServiceAccount="goToServiceAccountDetails"
        v-on:deleteServiceAccount="openServiceAccountDeletionDialog"
      />
      <ServiceAccountCreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createServiceAccount"
        ref="creationDialog"
      />
      <ServiceAccountDeletionDialog
        :serviceAccount="selectedServiceAccount"
        :dialog="deletionDialog"
        v-on:cancel="deletionDialog = false"
        v-on:deleteServiceAccount="deleteServiceAccount"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import ServiceAccountsTable from "@/components/Admin/ServiceAccounts/ServiceAccountsTable";
import ServiceAccountCreationDialog from "@/components/Admin/ServiceAccounts/ServiceAccountCreationDialog";
import ServiceAccountDeletionDialog from "@/components/Admin/ServiceAccounts/ServiceAccountDeletionDialog";

export default {
  name: "ServiceAccountsList",
  components: {
    ServiceAccountsTable,
    ServiceAccountCreationDialog,
    ServiceAccountDeletionDialog
  },
  mixins: [mixin],
  data() {
    return {
      title: "Service Accounts",
      creationDialog: false,
      deletionDialog: false,
      selectedServiceAccount: {},
      snackbar: false,
      errorMessage: "",
      displayInfo: false
    };
  },
  computed: {
    ...mapState({
      serviceAccounts: state => state.serviceAccounts.all,
      fetchAllLoading: state => state.serviceAccounts.fetchAll.pending,
      fetchAllError: state => state.serviceAccounts.fetchAll.error
    })
  },
  methods: {
    ...mapActions("serviceAccounts", { fetchAll: "fetchAll" }),
    ...mapActions("serviceAccounts", { createOne: "createOne" }),
    ...mapActions("serviceAccounts", { deleteOne: "deleteOne" }),
    refresh() {
      this.fetchAll();
    },
    openServiceAccountCreationDialog() {
      this.creationDialog = true;
    },
    openServiceAccountDeletionDialog(serviceAccount) {
      this.selectedServiceAccount = serviceAccount;
      this.deletionDialog = true;
    },
    goToServiceAccountDetails(serviceAccount) {
      this.$router.push(`/admin/service-accounts/${serviceAccount.uuid}`);
    },
    createServiceAccount(id, name, description, rootUrl) {
      this.createOne({
        id: id,
        name: name,
        description: description,
        url: rootUrl,
        redirectUris: [],
        webOrigins: []
      })
        .then(() => {
          this.refresh();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteServiceAccount(uuid) {
      this.deleteOne({ uuid: uuid })
        .then(() => {
          this.deletionDialog = false;
          this.selectedServiceAccount = {};
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>